export const DefaultOrganizationId = '00000';
export const AdministrationOrganizationId = '00001';
export const RepublicOrganizationId = '02683';
